import React from 'react';

// Material UI
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { styled, Button } from '@mui/material';
import { CancelButton, DeleteButton } from 'components/ui/buttons';

export default function ConfirmAction(props) {
    // Props
    const { open, onConfirm, onCancel, title, description, destructive, confirmText } = props;

    return (
        <Dialog open={open} onClose={onCancel}>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>{description}</DialogContent>
            <DialogActions>
                <CancelButton onClick={onCancel}>
                    Cancel
                </CancelButton>
                {destructive === true ? (
                    <DeleteButton onClick={onConfirm}>
                        {confirmText ? confirmText : 'Yes'}
                    </DeleteButton>
                ) : (
                    <ConfirmButton onClick={onConfirm}>
                        {confirmText ? confirmText : 'Yes'}
                    </ConfirmButton>
                )}
            </DialogActions>
        </Dialog>
    );
}
const ConfirmButton = styled(Button)(({ theme }) => ({
    backgroundColor: theme.palette.success.main,
    color: theme.palette.common.white,
    '&:hover': {
        backgroundColor: theme.palette.success.main,
    },
}));
ConfirmButton.defaultProps = { variant: 'contained' };
